// extracted by mini-css-extract-plugin
export var checkbox = "_3j-0";
export var circle = "_3j-3";
export var horizontalContainer = "_3j-7";
export var sm = "_3j-5";
export var switch0 = "_3j-2";
export var switchDisabled = "_3j-8";
export var switchEnabled = "_3j-1";
export var textSwitchContainer = "_3j-9";
export var textSwitchOption = "_3j-a";
export var textSwitchOptionSelected = "_3j-b";
export var verticalContainer = "_3j-6";
export var xs = "_3j-4";